/**
 * Session Repository Interface
 * Defines contract for session data access
 */

export class ISessionRepository {
  /**
   * Create new session
   * @param {string} userId
   * @param {string} courseId
   * @param {string} sectionId
   * @returns {Promise<Session>}
   */
  async createSession(userId, courseId, sectionId) {
    throw new Error('Method not implemented');
  }

  /**
   * Get session by ID
   * @param {string} sessionId
   * @returns {Promise<Session|null>}
   */
  async getSessionById(sessionId) {
    throw new Error('Method not implemented');
  }

  /**
   * Get active session for user
   * @param {string} userId
   * @param {string} courseId
   * @returns {Promise<Session|null>}
   */
  async getActiveSession(userId, courseId) {
    throw new Error('Method not implemented');
  }

  /**
   * Update session
   * @param {Session} session
   * @returns {Promise<Session>}
   */
  async updateSession(session) {
    throw new Error('Method not implemented');
  }

  /**
   * Complete session
   * @param {string} sessionId
   * @returns {Promise<Session>}
   */
  async completeSession(sessionId) {
    throw new Error('Method not implemented');
  }

  /**
   * Get session history for user
   * @param {string} userId
   * @param {string} courseId
   * @param {number} limit
   * @returns {Promise<Session[]>}
   */
  async getSessionHistory(userId, courseId, limit = 10) {
    throw new Error('Method not implemented');
  }
}
